<template>
  <div id="headertop" class="mui-bar mui-bar-nav">
    <!--<div class="headertop">
			<div class="btn-back" @click="back">
				<i class="fa fa-angle-left"></i>
			</div>
			<div class="title-name">
				{{title}}
			</div>
		</div>-->
    <header>
      <a class="mui-icon mui-icon-left-nav mui-pull-left" @click="back" />
      <h1 class="mui-title">{{ title }}</h1>
      <div class="mui-right"><slot name="mui-right" /></div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'Headertop',
  props: {
    title: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
.headertop{
	background:#26A2FF;
	height:0.8rem;
	display:flex;
	top:0;
	left:0;
	width:100%;
	color:#fff;
}
.btn-back{
	padding:0 0.36rem;
	position:relative;
	z-index:9;
}
.btn-back i{
	line-height:0.8rem;
	font-size:0.6rem;
}
.title-name{
	position:absolute;
	width:100%;
	display:inline-block;
	font-size:0.34rem;
	text-align:center;
	line-height:0.8rem;
}
.mui-bar .mui-icon{
	color:#fff;
}
.mui-right{
	float:right;
	line-height:44px;
}
</style>



// WEBPACK FOOTER //
// src/components/headertop.vue